<template>
  <div class="type filter-form">
    <b-form-group>
      <b-form-radio v-for="option in options"
                    :name="name"
                    :value="option"
                    v-model="selected"
                    @input="emitChanges"
      >
        {{ option.text }}
      </b-form-radio>
    </b-form-group>

    <p class="text-right">
      <b-button class="btn-as-link" @click="reset">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
import filtersMixin from "./mixin";

export default {
  mixins: [filtersMixin],

  data () {
    return {
      selected: null
    }
  },

  methods: {
    reset () {
      this.selected = null
      this.emitChanges()
    }
  }
}
</script>
